module.exports = __webpack_public_path__ + "img/romantik-guide4.78fa58ab.jpg";